import { usePathname } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { getChatbotScriptSrc } from "./utils";
import { client } from "./hono";
import { t } from "@/lib/localization";

const disabledPaths = [
    "/demo",
    "/lms-demo",
    "assistant-demo",
    "/play/",
    "/lomda-render",
];

export default function EmbedChatbot() {
    const [encryptedUser, setEncryptedUser] = useState<string | null>(null);

    const pathname = usePathname();
    const { user } = useAuth();

    const isDisabledPath = useMemo(
        () => !user || disabledPaths.some((path) => pathname.includes(path)),
        [pathname, user]
    );

    useEffect(() => {
        const fetchEncryptedUser = async () => {
            const res =
                await client.api.chatbots.v2["support-chatbot-user"].$get();

            if (res.ok) {
                const { encryptedChatbotUser } = await res.json();
                setEncryptedUser(encryptedChatbotUser);
            }
        };

        if (!isDisabledPath) {
            fetchEncryptedUser();
        }
    }, [isDisabledPath]);

    if (user?.admin || isDisabledPath || !encryptedUser) {
        return null;
    }

    const src = getChatbotScriptSrc("v2");

    return (
        <script
            src={src}
            data-user={encryptedUser}
            data-env="prod"
            data-chatbot-id={process.env.NEXT_PUBLIC_YEDALABS_CHATBOT_ID}
            async
        />
    );
}
